import React from 'react';

import { useTranslation } from 'react-i18next';

import ErrorMessage from 'components/application/ErrorMessage';
import TextField from 'components/application/TextField';

export default function SubcontractorsForm({
  currentSubcontractor,
  onSubcontractorInputChange,
  removeErrorStyling,
  requestError,
  sidePanelFieldRef,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'subcontractors.SubcontractorsForm',
  });

  return (
    <div className='popup__body-form'>
      <ErrorMessage
        isFallback={requestError.isFallback}
        validationErrors={requestError.validationErrors}
        wrapperClassName='form-container'
      />
      <div className='form-container'>
        <TextField
          autoFocus={true}
          fieldError={requestError.validationErrors.name}
          inputRef={sidePanelFieldRef}
          isRequired={true}
          label={i18nT('textField.label')}
          name='name'
          onChange={onSubcontractorInputChange}
          removeErrorStyling={removeErrorStyling}
          value={currentSubcontractor.name}
        />
      </div>
    </div>
  );
}
